import { combineReducers } from 'redux';
import activeResearchReducer from '../../features/activeResearch/activeResearchSlice';
import adReducer from '../../features/ad/adSlice';
import authReducer from '../../features/auth/authSlice';
import companyReducer from '../../features/company/companySlice';
import foldersReducer from '../../features/folders/foldersSlice';
import modalsReducer from '../../features/modals/modalsSlice';
import pieceworkReducer from '../../features/piecework/pieceworkSlice';
import procedureEvents from '../../features/procedureEvent/reducer';
import subscriptionReducer from '../../features/subscription/subscriptionSlice';
import usersReducer from '../../features/users/usersSlice';
import adStudies from '../../store/adStudies/reducer';
import announcementsReducer from '../../store/announcements/reducer';
import appManager from '../../store/appManager/reducer';
import comparativeStudies from '../../store/comparativeStudies/reducer';
import comparativeStudyComparisons from '../../store/comparativeStudyComparisons/reducer';
import comparativeStudyComparisonsSelect from '../../store/comparativeStudyComparisonsSelect/reducer';

import loader from '../../store/loader/reducer';
import marketStudies from '../../store/marketStudies/reducer';
import propertyTypologies from '../../store/propertyTypologies/reducer';

const combinedReducer = combineReducers({
  //redux toolkit reducers
  activeResearch: activeResearchReducer,
  ad: adReducer,
  piecework: pieceworkReducer,
  auth: authReducer,
  folders: foldersReducer,
  modals: modalsReducer,
  users: usersReducer,
  company: companyReducer,
  subscription: subscriptionReducer,
  // classic reducers
  comparativeStudies,
  comparativeStudyComparisons,
  comparativeStudyComparisonsSelect,
  marketStudies,
  appManager,
  loader,
  propertyTypologies,
  adStudies,
  procedureEvents,
  announcementsReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'app/resetAll') {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default rootReducer;
